<template>
    <div>
        <nav class="footer-nav md:hidden bg-comet w-full tac fixed pin-b pin-x z-50 px-4 md:px-2 py-1">
            <div class="mx-auto relative max-w-3xl text-center h-10 flex justify-around items-center">
                <router-link tag="button" :to="{ name: 'home' }" class="nav-item">
                    <i class="fal fa-home text-3xl"></i>
                </router-link>

                <router-link tag="button" :to="{ name: 'notifications' }" class="nav-item relative">
                    <i class="fal fa-bell text-3xl"></i>
                    <span
                        class="h-4 flex -mt-1 -mr-2 absolute pin-t pin-r items-center justify-center bg-red text-white rounded-full text-xs px-1"
                        v-if="notificationsCount" v-text="notificationsCount"></span>
                </router-link>

                <router-link tag="button" :to="{ name: 'account' }" class="nav-item">
                    <i class="fal fa-cog text-3xl"></i>
                </router-link>

                <button class="nav-item" @click="$parent.$refs.navigation.toggle()">
                    <i class="fal fa-bars text-3xl"></i>
                </button>

            </div>
        </nav>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {

    computed: {
        ...mapState(['notifications']),
        notificationsCount() {
            return this.notifications.length
        }
    },
}
</script>

<style>
.navbar-bg {
    background: url('../assets/gradients/1.jpg');
    background-size: 100%;
}
</style>
